import { canAssignRoles } from '@infras/shared-types';
import { AdminGate } from '../components/AdminGate';
import { TeamRoles } from '../components/TeamRoles';
import { useMe } from '../lib/useMe';

/** Administration → Users & roles. Root only, matching the API's own gate. */
export function UsersRolesPage() {
  const { me } = useMe();
  return (
    <AdminGate allowed={!!me && canAssignRoles(me.role)} need="root users">
      <div className="page stack">
        <div className="detail-head">
          <h2>Users &amp; roles</h2>
        </div>
        <TeamRoles />
        {/* Stated up front rather than only failing on submit — the server refuses
            it, and finding that out by trying is a worse way to learn a rule. */}
        <p className="muted text-2xs">
          The last remaining root can&apos;t be demoted; promote someone else first.
        </p>
      </div>
    </AdminGate>
  );
}
